import * as R from 'ramda'

/**
 * No matter what action was just triggered, this middlware will handle any
 * error and throw a message in the console.
 *
 * Updated to include "silent" errors from redux-api-middleware
 */
// eslint-disable-next-line unused-imports/no-unused-vars
export default state => next => action => {
  if (!action.payload) return next(action)
  const { payload } = action

  // this catches invalid RSAA formats
  if (payload.name === 'InvalidRSAA') {
    console.error(payload.validationErrors.join('. '))
  }

  // this catches invalid RSAA body functions
  if (payload.name === 'RequestError') {
    console.error(action.type, payload.message)
  }

  if (payload.response) {
    // dont log out any payload response that way
    // we don't send TrackJs any member PHI/PII
    const {
      response: { message, errors },
    } = payload

    const err = []
    if (message) err.push(message)
    if (errors) err.push(errors.join('. '))

    // Enhanced logging for Invalid Token errors
    if (message === 'Invalid Token') {
      const debugContext = {
        timestamp: new Date().toISOString(),
        actionType: action.type,
        status: payload.status,
        endpoint: action.meta?.endpoint || 'unknown',
        isFromCache: action.meta?.fromCache || false,
        hasToken: !!localStorage.getItem('token'),
        tokenLength: localStorage.getItem('token')?.length || 0,
        aud: localStorage.getItem('aud'),
        currentUrl: window.location.href,
        previousUrl: document.referrer,
        userAgent: navigator.userAgent,
      }
      console.error('[INVALID_TOKEN_DEBUG]', debugContext)

      // Send to tracking service if available
      if (window.trackJs) {
        window.trackJs.track('Invalid Token Error', debugContext)
      }
    }

    // only log the errors if there are any
    // this should avoid the empty string error
    if (err.length > 0) console.error(err.join('\n'))
  }

  // Some APIs like Jira will return a funky error that's not really
  // JSON. We need to capture this and parse it out so that our reducers
  // don't need to think about it. They just store the response or whatever.
  if (payload.name && payload.name === 'ApiError') {
    const nextAction = {
      ...action,
      payload: JSON.parse(JSON.stringify(payload)),
    }
    return next(nextAction)
  }

  // Service unavailable
  if (payload.status === 503) {
    const errorMessagePath = ['payload', 'response', 'message']
    const nextAction = R.when(
      R.pathSatisfies(R.isNil, errorMessagePath),
      R.assocPath(errorMessagePath, 'Service unavailable'),
    )(action)
    window.location = '/serviceUnavailable'
    return next(nextAction)
  }

  // convert preflight request error to _ERROR to be handled by reducer, default behavior
  // in redux-api-middleware is to keep it as _REQUEST with action.error = true.
  if (action.error && action.type.includes('REQUEST')) {
    const nextAction = R.compose(
      R.assocPath(
        ['payload', 'response', 'message'],
        'There was an error with your request',
      ),
      R.assocPath(['type'], action.type.replace('_REQUEST', '_ERROR')),
    )(action)

    return next(nextAction)
  }

  return next(action)
}
